export const BUILT_IN_PAYMENT_BUTTONS_DATA_ATTR = 'paymentButtons';
